document.addEventListener('DOMContentLoaded', function() {
    // console.log('DOM fully loaded and parsed');

    function addTouchEventListeners(selector) {
        var productItems = document.querySelectorAll(selector);
        // console.log('Found product items:', productItems.length);

        productItems.forEach(function(item, index) {
            // console.log('Adding touch event listener to item:', index);

            item.addEventListener('touchstart', function() {
                // console.log('Touched item:', index);
                var bgUnder = item.querySelector('.product-item__bg__under');
                if (bgUnder) {
                    // console.log('Found .product-item__bg__under, adding class wzg-touched-active');
                    bgUnder.classList.add('wzg-touched-active');
                } else {
                    // console.log('Could not find .product-item__bg__under');
                }
            });

            item.addEventListener('touchend', function() {
                // console.log('Touch ended on item:', index);
                var bgUnder = item.querySelector('.product-item__bg__under');
                if (bgUnder) {
                    // console.log('Found .product-item__bg__under, removing class wzg-touched-active');
                    bgUnder.classList.remove('wzg-touched-active');
                } else {
                    // console.log('Could not find .product-item__bg__under');
                }
            });
        });
    }

    // Check if the body has class 'template-product'
    if (document.body.classList.contains('template-product')) {
        // console.log('User is on the product page');

        // Add touch event listeners to .product-item elements on product pages
        addTouchEventListeners('.product-item');

        // Function to observe changes in the tab content
        function observeTabContent() {
            var tabContents = document.querySelectorAll('.tab-content');
            // console.log('Found tab contents:', tabContents.length);

            tabContents.forEach(function(tabContent, index) {
                // console.log('Observing tab content:', index);

                var observer = new MutationObserver(function(mutationsList, observer) {
                    // console.log('Tab content changed:', index);
                    addTouchEventListeners('.product-item');
                });

                observer.observe(tabContent, { childList: true, subtree: true });
            });
        }

        // Initial call to observe tab content
        observeTabContent();
    } else {
        // console.log('User is on a non-product page');

        // Add touch event listeners to .product-item__image.double__image elements on non-product pages
        addTouchEventListeners('.product-item__image.double__image');
    }
});
